import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.js';
import './styles/global.scss';

const isProd = process.env.NODE_ENV === 'production';

if (isProd) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

createApp(App).use(router).mount('#app');
